<template>
  <div class="rule-detail">
    <div style="margin-bottom: 10px;">
      <span>地区：{{flowDetail.area}}</span>
      <span style="margin-left:15px;">分子公司：{{flowDetail.company}}</span>
      <span style="margin-left:15px;">时间：{{flowDetail.time | filterTime}}</span>
      <!-- <Button
        type="primary"
        size="small"
        @click="initRuleDetail"
        style="margin-left: 20px;"
      >初始化表格</Button>
      <span style="color:#ed3f14">（若表格无数据，请点击初始化表格按钮）</span> -->
      <Button
        type="primary"
        @click="saveRuleDetail"
        size="small"
        style="margin:0 0 0 20px;"
        :disabled="readonly"
      >保存</Button>
      <span style="color:#ed3f14">（填写过程及填写结束后请注意点击保存）</span>
    </div>
    <Table
      :columns="columns"
      border
      :data="ruleData"
    ></Table>
  </div>
</template>

<script>
import requestUrls from '@/lib/requestUrls'
import ajax from '@/lib/ajax'

export default {
  name: 'commissionRuleDetail',
  props: {
    flowDetail: {
      type: Object,
      default() {
        return {
          area: '',
          company: ''
        }
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns: [
        {
          title: '平台',
          align: 'center',
          key: 'title',
          width: 60
        },
        {
          title: '单个项目单次开标服务费/标书款收入区间',
          align: 'center',
          children: [
            {
              title: '最小值',
              align: 'center',
              width: 80,
              render: (h, params) => {
                return h('div', params.row.priceTierDb.minPrice)
              }
            },
            {
              title: '最大值',
              align: 'center',
              width: 80,
              render: (h, params) => {
                return h('div', params.row.priceTierDb.maxPrice)
              }
            }
          ]
        },
        {
          title: '公司给予政策',
          align: 'center',
          children: [
            {
              title: '一般',
              align: 'center',
              render: (h, params) => {
                let data = (params.row.priceTierDb.pushMoney * 100).toString().substr(0, 2) + '%'
                return h('div', data)
              }
            }
          ]
        },
        {
          title: '项目数量',
          align: 'center',
          width: 65,
          render: (h, params) => {
            return h('div', 'N')
          }
        },
        {
          title: '业务人员',
          align: 'center',
          children: [
            {
              title: '奖励项分配规则',
              align: 'center',
              children: [
                {
                  title: '1、业务奖金',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.yW_award1,
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.yW_award1 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                },
                {
                  title: '2、月度目标达成',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.yW_award2
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.yW_award2 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                },
                {
                  title: '3、年度目标达成',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.yW_award3
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.yW_award3 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                }
              ]
            },
            {
              title: '扣除项规则（元/项）',
              align: 'center',
              children: [
                {
                  title: '（1）废标',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.yW_deduct1
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.yW_deduct1 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                },
                {
                  title: '（2）有效质疑',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.yW_deduct2
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.yW_deduct2 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                },
                {
                  title: '（3）有效投诉',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.yW_deduct3
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.yW_deduct3 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                },
                {
                  title: '（4）其他',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.yW_deduct4
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.yW_deduct4 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                }
              ]
            }
          ]
        },
        {
          title: '项目及后勤人员',
          align: 'center',
          children: [
            {
              title: '奖励项分配规则（4，5，只能选填其中一项）',
              align: 'center',
              children: [
                {
                  title: '4、项目奖金（按%计算）',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.hQ_award1
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.hQ_award1 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                },
                {
                  title: '5、项目奖金（按单项计算）',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.hQ_award2
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.hQ_award2 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                },
                {
                  title: '6、月度目标达成',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.hQ_award3
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.hQ_award3 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                },
                {
                  title: '7、年度目标达成',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.hQ_award4
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.hQ_award4 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                },
              ]
            },
            {
              title: '扣除项规则（元/项）',
              align: 'center',
              children: [
                {
                  title: '（5）废标',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.hQ_deduct1
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.hQ_deduct1 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                },
                {
                  title: '（6）有效质疑',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.hQ_deduct2
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.hQ_deduct2 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                },
                {
                  title: '（7）有效投诉',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.hQ_deduct3
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.hQ_deduct3 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                },
                {
                  title: '（8）其他',
                  align: 'center',
                  render: (h, params) => {
                    return h('input', {
                      domProps: {
                        value: this.fillData[params.index].companyBonus.hQ_deduct4
                      },
                      attrs: {
                        readonly: this.readonly
                      },
                      on: {
                        input: (event) => {
                          this.fillData[params.index].companyBonus.hQ_deduct4 = event.target.value
                        }
                      },
                      style: {
                        width: '100%',
                        border: '1px solid #ddd'
                      }
                    })
                  }
                }
              ]
            }
          ]
        }
      ],
      ruleData: [],
      fillData: []
    }
  },
  methods: {
    async getRuleList(companyName = '') {
      let rep = await ajax.get(requestUrls.CompanyBonus.GetList, {
        params: {
          filter: `cName=="${companyName}"`
        }
      })
      if (rep.data.success) {
        return rep.data.result
      }
      return {}
    },
    async saveRuleDetail() {
      this.$Spin.show()
      try {
        let rep = await ajax.post(requestUrls.CompanyBonus.BonusUpdateList, this.fillData)
        this.$Spin.hide()
        if (rep.data.success) {
          this.$Message.success('保存成功')
        } else {
          this.$Message.error('保存失败')
        }
      } catch (err) {
        this.$Spin.hide()
        console.error(err)
        this.$Message.error('保存失败')
      }
    },
    async initRuleDetail() {
      this.$Spin.hide()
      try {
        let time = new Date(this.flowDetail.time)
        time = time.toLocaleDateString().replace(/\//g, '-')
        let rep = await ajax.post(requestUrls.CompanyBonus.Init, {
          cName: [this.flowDetail.company],
          dt: time,
          status: '2'
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.$Message.success('初始化成功')
          // 刷新数据
          this.refreshData()
        } else {
          this.$Message.error('初始化失败')
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('初始化失败')
      }
    },
    async refreshData() {
      // this.ruleData = []
      // this.fillData = []
      let ruleData = await this.getRuleList(this.flowDetail.company)
      if (!ruleData['3']) {
        this.ruleData = []
        this.fillData = []
        return
      }
      this.ruleData = []
      this.fillData = []
      ruleData['3'].forEach((item, index) => {
        item.title = '内网立项'
        item.cellClassName = {
          title: 'rowspan1'
        }
        this.ruleData.push(item)
        this.fillData.push({
          companyBonus: {
            id: item.id,
            yW_award1: item.yW_award1,
            yW_award2: item.yW_award2,
            yW_award3: item.yW_award3,
            yW_deduct1: item.yW_deduct1,
            yW_deduct2: item.yW_deduct2,
            yW_deduct3: item.yW_deduct3,
            yW_deduct4: item.yW_deduct4,
            hQ_award1: item.hQ_award1,
            hQ_award2: item.hQ_award2,
            hQ_award3: item.hQ_award3,
            hQ_award4: item.hQ_award4,
            hQ_deduct1: item.hQ_deduct1,
            hQ_deduct2: item.hQ_deduct2,
            hQ_deduct3: item.hQ_deduct3,
            hQ_deduct4: item.hQ_deduct4,
          }
        })
      })
      // ruleData['2'].forEach(item => {
      //   item.title = '内网立项'
      //   item.cellClassName = {
      //     title: 'rowspan2'
      //   }
      //   this.ruleData.push(item)
      //   this.fillData.push({
      //     companyBonus: {
      //       id: item.id,
      //       yW_award1: item.yW_award1,
      //       yW_award2: item.yW_award2,
      //       yW_award3: item.yW_award3,
      //       yW_deduct1: item.yW_deduct1,
      //       yW_deduct2: item.yW_deduct2,
      //       yW_deduct3: item.yW_deduct3,
      //       yW_deduct4: item.yW_deduct4,
      //       hQ_award1: item.hQ_award1,
      //       hQ_award2: item.hQ_award2,
      //       hQ_award3: item.hQ_award3,
      //       hQ_award4: item.hQ_award4,
      //       hQ_deduct1: item.hQ_deduct1,
      //       hQ_deduct2: item.hQ_deduct2,
      //       hQ_deduct3: item.hQ_deduct3,
      //       hQ_deduct4: item.hQ_deduct4,
      //     }
      //   })
      // })
    }
  },
  watch: {
    flowDetail: {
      async handler(val) {
        if (val.company) {
          this.refreshData()
        }
      },
      immediate: true,
      deep: true
    }
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return ''
      }
      let time = new Date(val)
      return time.toLocaleDateString().replace(/\//g, '-')
    }
  }
}
</script>

<style lang="less">
.rule-detail {
  .ivu-table-cell {
    padding: 0 5px;
  }
}
</style>
